import {types, flow} from 'mobx-state-tree';
import * as api from '../../services/api';
import LanguageModel from '../LanguageModel';

const LanguagesListModel = types
  .model('LanguagesListModel', {
    isLoading: types.optional(types.boolean, false),
    entries: types.map(LanguageModel)
  })
  .actions(self => ({
    loadEntries: flow(function*() {
      self.isLoading = true;
      const response = yield api.getLanguages();
      if (response.status === 200) {
        const languages = response.data.languages;
        // tslint:disable-next-line: no-any
        self.entries = languages.reduce((cs: any, c: any) => {
          cs[String(c.id)] = c;
          return cs;
        },                              {});
      }
      self.isLoading = false;
    })
  }));

export type LanguagesListModelType = typeof LanguagesListModel.Type;
export default LanguagesListModel;



// WEBPACK FOOTER //
// ./src/models/LanguagesListModel/LanguagesListModel.ts